import React from 'react';
import {Link} from 'react-router-dom';
import {Navbar} from '../../components';

const Dashboard = () => {
  return (
    <>
      <Navbar />
      <div>
        <div>
          <h1>Hola dashboard</h1>
        </div>
        <div>
          <Link to="/home">Home</Link>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
